import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: 'div' | 'li' | 'section';
};
export function Reveal({
  children,
  className = '',
  delay = 0,
  as = 'div'
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  const MotionTag = motion[as];
  if (reduceMotion) {
    const Tag = as;
    return <Tag className={className} data-id="element-196" data-mp="2jqycfaw008ov">{children}</Tag>;
  }
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-72px'
  }} transition={{
    duration: 0.28,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-197" data-mp="2jsjahahiu9rh">
      {children}
    </MotionTag>;
}